<template>
  <div v-if="showModal">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-dialog" role="document">
            <div class="header">
              <button type="button" class="btn  close-button" @click="closeModal" aria-label="Close">
                <i class="fas fa-times"></i>
              </button>
            </div>
            <div class="modal-body">
              <div class="modal-card">
                <p class="modal-title">Activiteit verwijderen</p>
                <div class="divider"></div>
                <div class="content">
                  <p>Ben je zeker dat je deze activiteit wil verwijderen?</p>
                  <div class="row">
                    <button class="btn btn-sandpiper" type="button" @click="deleteConfirmed">Activiteiten
                      Verwijderen
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>

</template>

<script>

  export default {
    name: "DeleteActivityModal",
    components: {},
    mixins: [],
    props: {
      showModal: Boolean,
    },
    data() {
      return {}
    },
    computed: {},
    methods: {
      closeModal() {
        this.$emit("modalClosed");
      },
      deleteConfirmed() {
        this.$emit("deleteActivityConfirmed");
      },

    },
    created() {
    }
  }
</script>

<style lang="scss" scoped>

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(8, 43, 66, .97);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-dialog {
    pointer-events: all;
  }

  .close-button {
    float: right;
    font-size: 2rem;
    color: $font-light;
    line-height: 1;
  }

  .modal-card {
    background-color: white;
    border-radius: 5px;
    box-shadow: $default-shadow;
    padding: 25px;
    margin-top: 25px;
    display: flex;
    flex-direction: column;

    .modal-title {
      font-size: $title-size;
      margin-bottom: 34px;
    }

    .divider {
      height: 2px;
      background-color: $font-grey;
      margin-bottom: 20px;
    }

  }

  .header {
    display: flex;
    height: 50px;
  }

  .container {
    background-color: white;
    border-radius: 5px;
    box-shadow: $default-shadow;
    padding: 25px;
  }


  .title {
    font-size: 1.25rem;
  }

</style>